var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"left":"0"},attrs:{"id":"bdIframe","src":_vm.url,"frameborder":"0","scrolling":"auto","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }